// MobileFrame — phone bezel for projectType='mobile'.
// Renders a phone silhouette with notch and home-indicator bar.
// Green accent; thumbnail insets in the screen area.

export const MobileFrame = {
  flow: 'column',
  width: '100%',
  height: '100%',
  position: 'relative',
  round: 'inherit',
  overflow: 'hidden',
  alignItems: 'center',
  justifyContent: 'center',

  // Phone outline container
  PhoneOuter: {
    position: 'relative',
    width: 'D',
    height: 'E1',
    round: 'C',
    border: '2px solid',
    borderColor: 'green.35',
    background: 'black.4',
    overflow: 'hidden',
    flexShrink: '0',
    margin: 'auto',
    boxShadow: '0 0 0 0',

    // Notch
    Notch: {
      position: 'absolute',
      top: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'A2',
      height: 'W',
      background: 'black.7',
      borderBottomLeftRadius: 'W',
      borderBottomRightRadius: 'W',
      zIndex: '3',
      pointerEvents: 'none'
    },

    // Screen — thumbnail insets here
    Screen: {
      position: 'absolute',
      inset: '0',
      overflow: 'hidden',
      background: 'green.06',

      EmptyState: {
        if: (el, s) => !s.screenshot && !s.screenshotDev && !s.icon,
        position: 'absolute',
        inset: '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'W',
        padding: 'A',
        pointerEvents: 'none',

        Glyph: {
          fontSize: 'A',
          color: 'green.5',
          text: '☰',
          marginTop: 'W'
        },
        Hint: {
          tag: 'span',
          text: 'Tap to design',
          fontSize: 'Z1',
          color: 'white.2',
          fontStyle: 'italic',
          textAlign: 'center',
          lineHeight: '1.3'
        }
      }
    },

    // Home bar
    HomeBar: {
      position: 'absolute',
      bottom: 'V',
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'A2',
      height: 'Z',
      round: 'Z',
      background: 'white.25',
      zIndex: '3',
      pointerEvents: 'none'
    }
  },

  // Accent border on tile
  AccentBorder: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: 'V',
    height: '100%',
    background: 'green',
    opacity: '0.7',
    pointerEvents: 'none'
  }
}
